module.exports = __webpack_public_path__ + "static/media/users-guide.ec3f8f8c.csv";